import { useRef, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoCamera } from "@fortawesome/free-solid-svg-icons";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { categories } from "../../helpers/mock-data";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { createTutorial } from "../../services/documents/documents.context";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";


export const TutorialUpdatePage = () => {

    const { token } = useAuth();

    const fileButton = useRef();

    const [inputData, setInputData] = useState({
        document: '',
        title: '',
        field: '',
    });

    const [prevName, setPrevName] = useState(null);

    const [loading, setLoading] = useState(false);
    const [valError, setValError] = useState({
        caption: null,
        message: null
    });

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        const { title, document, field } = inputData;
        return isNull (title) || isNull(document) || isNull(field);
    }


    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Add a Tutorial"} />
            {(loading) && <Loader />}
            {valError && 
                <AppAlert 
                    caption={valError.caption}
                    message={valError.message}
                    close={() => setValError()}
                    accept={"Ok"}
                    acceptAction={valError.acceptAction}
                />
            }
            <div className="form-container">
                <div className="input-container">
                    <span className="input-cap">
                        Title
                        <span className="req-asterix">*</span>
                    </span>
                    
                    <input 
                        type="text" 
                        placeholder="Enter tutorial title" 
                        className="input"
                        onChange={(e) => setInputData((data) => 
                            ({...data, title: e.target.value})
                        )}
                        value={inputData.title}
                    />
                </div>
                <div className="input-container">
                    <span className="input-cap">
                        Field of study
                        <span className="req-asterix">*</span>
                    </span>
                    <select 
                        type="text" 
                        name="category" 
                        id="category" 
                        className={classNames("input", "category")} 
                        required
                        onChange={(e) => setInputData((data) => (
                            {...data, field: e.target.value}
                        ))}
                    >
                        <option defaultValue={''} selected disabled>
                            ---Choose subject area---
                        </option>
                        {categories.map((category, i) => (
                            <option value={category} key={i} >{category}</option>
                        ))}
                    </select>
                </div>
                <div className="file-btn-container">
                    <input 
                        type="file"
                        className="file-button"
                        ref={fileButton}
                        onChange={(e) => {
                            e.preventDefault();
                            let fileType = e.target.files[0].type.split("/")[1];

                            if (fileType !== "pdf") {
                                setValError(
                                    { 
                                        caption: "Error!",
                                        message: `Invalid file of type ${fileType}! Please upload a file of type pdf`,
                                        acceptAction: () => {
                                            setValError();
                                        },
                                        accept: "OK"
                                    }
                                )
                                return;
                            }
                            const uploadedFile = e.target.files[0];
                            const fileName = uploadedFile.name;
                            setPrevName(fileName);
                            setInputData((data) => (
                                {...data, document: e.target.files[0]}
                            ))
                        }} 
                    />
                    <button
                        onClick={() => fileButton.current.click()}
                        className="file-click"
                    >
                        <FontAwesomeIcon icon={faVideoCamera} style={{marginRight: 8}} />
                        Upload file
                    </button>
                </div>

                { prevName &&( 
                <div className={classNames("prev")}>
                    <FontAwesomeIcon icon={faFilePdf} />
                    {prevName}
                </div>)
                }
                
                <button 
                    className="form-button"
                    onClick={ async (e) => {
                        e.preventDefault();
                        if (inputRequired()) {
                           
                            setValError(
                                { 
                                    caption: "Error!",
                                    message: "Please provide all the required data",
                                    acceptAction: () => {
                                        setValError();
                                    }
                                }
                            )
                            return;
                        }
                        setLoading(true);
                        const d = await createTutorial(token, inputData);
                        setLoading(false);
                        setValError({
                            caption: "Success",
                            message: d?.message,
                            acceptAction: () => {
                                setValError();
                                window.location.reload();
                            }
                        })
                    }}
                >
                    Upload Tutorial
                </button>
            </div>
        </div>
    );
}